import angular from 'angular';
import process from './process';
import processesDirective from './processes.directive';
import processesController from './processes.controller';


export default angular.module('app.components.advisory.pra.processes', [
  process
])
  .directive('praProcesses', processesDirective)
  .controller('PRAProcessesController', processesController)
  .name;

console.log('app.components.advisory.pra.processes created');
